import { RouteConfig } from "vue-router";
import CustomerLayout from "@/layout/CustomerLayout.vue";
import MenuForClient from "@/views/client/MenuForClient.vue";
import store from "@/store";
import { apolloClient } from "@/apollo";
import { GET_CLIENT_MENU } from "@/queries/customer/query.graphql";
import { startOrder } from "./utils";

export const customerRoutes: Array<RouteConfig> = [
  {
    path: "/customer/:menuId/:tableId",
    component: CustomerLayout,
    beforeEnter: (to, from, next) => {
      if (store.getters["authModule/isClientAuthenticated"]) {
        store.commit("loadersModule/toggleGlobalLoader", true);
        new Promise((resolve, reject) => {
          if (
            store.getters["authModule/menuId"] !== to.params.menuId ||
            store.getters["authModule/tableId"] !== to.params.tableId
          ) {
            return reject();
          } else {
            apolloClient
              .query({
                query: GET_CLIENT_MENU,
                variables: {
                  id: to.params.menuId,
                },
              })
              .then(resolve)
              .catch(reject);
          }
        })
          .then((data: any) => {
            store.commit("loadersModule/toggleGlobalLoader", false);
            next();
          })
          .catch((error) => {
            store.commit("authModule/reintiateOrder");
            startOrder(to, from, next);
          });
        return;
      }
      store.commit("authModule/reintiateOrder");
      store.commit("loadersModule/toggleGlobalLoader", true);
      startOrder(to, from, next);
    },
    children: [
      { path: "/customer/:menuId/:tableId", redirect: "menu" },
      {
        path: "menu",
        component: MenuForClient,
        name: "menu-for-customer",
      },
      {
        path: "/customer/:menuId/:tableId/complete",
        name: "order-complete",
        component: () => import("@/views/client/OrderCompleted.vue"),
        meta: { noBasket: true },
      },
    ],
  },
];
